module.exports = __webpack_public_path__ + "static/img/spring_huangguoganPic.ac6b997b.png";